/// <amd-module name="Feed/Connect/Protocols/Python" />
import { replaceRouteValues } from "VSS/Platform/Util/Url";

import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

import { PackagingProcotol } from "../Protocol";
import { PackagingTool, ToolId } from "../Tool";

import * as Res from "Feed/Connect/Resources";

class PythonProtocol extends PackagingProcotol {
    constructor() {
        super("Python");
    }

    public readonly area = "pypi";

    public getFeedUrl(packagingService: PackagingService, feed: IUxFeedView) {
        // TODO: Move route resolution to endpoints within this object
        const path = replaceRouteValues("_packaging/{feedId}/{area}/{resource}/{packageName}/", {
            feedId: feed.name,
            area: this.area,
            resource: "simple"
        });

        return packagingService.getUrl(feed.project, path);
    }
}

const PythonP = new PythonProtocol();

class PythonTool extends PackagingTool {
    constructor(
        id: ToolId,
        name: string,
        imageName: string,
        private toolLinkId: number,
        allowNonMembers: boolean = true
    ) {
        super(id, name, PythonP, { src: `ms.feed/feed-connect/Content/${imageName}` }, allowNonMembers);
    }

    public getToolLink = () => ({
        href: `https://go.microsoft.com/fwlink/?linkid=${this.toolLinkId}`,
        children: `${Res.CommandLineReference}`
    });
}

export const pip = new PythonTool(ToolId.pip, "pip", "pip.svg", 2103690);
export const twine = new PythonTool(ToolId.twine, "twine", "python.svg", 2103968, false);

twine.supportsGet = (feed: IUxFeedView) => {
    return false;
};

// TODO: Move URL generation into a set of "endpoints" for a protocol, and have twine pass the location Id for the download endpoint
twine.getFeedUrl = (packagingService: PackagingService, feed: IUxFeedView) => {
    // Note: We use feed.name here rather than fullyQualifiedName because twine
    // only supports publishing, and you can't publish to a view.
    const path = replaceRouteValues("_packaging/{feedId}/{area}/{resource}", {
        feedId: feed.name,
        area: PythonP.area,
        resource: "upload"
    });

    return packagingService.getUrl(feed.project, path);
};
